import * as Headless from '@headlessui/react';
import { ReactNode } from 'react';
import RequiredIndicator from '@/components/RequiredIndicator';
import Text from '@/components/Text';
import cn from '@/utils/cn';
import isString from '@/utils/typeGuards/isString';

type TProps = {
  className?: string;
  children: ReactNode;
  shouldLocalize?: boolean;
  withRequiredIndicator?: boolean;
} & Omit<Headless.LegendProps, 'as' | 'className'>;

export const Legend = ({
  className,
  children,
  shouldLocalize = true,
  withRequiredIndicator = false,
  ...props
}: TProps) => {
  const shouldLocalizeText = shouldLocalize && isString(children);

  return (
    <Headless.Legend
      data-slot="legend"
      {...props}
      className={cn(
        'flex items-baseline font-normal text-base text-grayscale-darkGray data-disabled:opacity-50',
        className
      )}
    >
      {shouldLocalizeText ? <Text>{children}</Text> : children}
      {withRequiredIndicator ? <RequiredIndicator /> : null}
    </Headless.Legend>
  );
};
